import bigInt from 'big-integer'
export const MAX_ALLOWANCE = BigInt(bigInt(2).pow(220).minus(1).valueOf())
